export default "__VITE_ASSET__c7c84164__"